import { useTranslation } from 'react-i18next';

import { AnalysisMarkdown, AnalysisSubHeader, NumberedCard } from '../../../../components';
import type { YougovData } from '../../model/yougovData.schema';

interface AiInsightsProps {
  insights: YougovData['insights'];
}

export const AiInsights = ({ insights }: AiInsightsProps) => {
  const { t } = useTranslation('analysis');

  if (!insights) return null;

  return (
    <div className="flex flex-col gap-6">
      <AnalysisSubHeader
        title={t('analysisResult.marketingPerformance.aiInsights')}
        subtitle={t('analysisResult.marketingPerformance.aiInsightsSubtitle')}
        subtitleTone="meta"
      />
      <div className="flex flex-col gap-8">
        <div>
          <div className="rounded-[10px] bg-surface p-xl dark:bg-surface-raised">
            {/* Two columns from `lg` up: the summary runs long enough that a full-width
                measure costs a reader the line. */}
            <AnalysisMarkdown
              text={insights.paragraph}
              className="text-pretty text-body-lg text-foreground lg:columns-2 lg:gap-8"
            />
          </div>
          <p className="mt-2 text-xs text-muted-foreground">
            {t('analysisResult.marketingPerformance.insightsCoverFullRange')}
          </p>
        </div>
        <div className="grid grid-cols-1 items-stretch gap-3 md:grid-cols-2 lg:grid-cols-3">
          {insights.tldr.bullet.map((bullet, index) => (
            <NumberedCard key={index} position={index + 1}>
              <AnalysisMarkdown text={bullet} className="text-body-md text-foreground-alt" />
            </NumberedCard>
          ))}
        </div>
      </div>
    </div>
  );
};
